import React from 'react'
import {LanguageSelector} from './LanguageSelector'

/** Logo + language on top row; login/register links on the row below (auth layouts). */
export function AuthSignHeader(props: {
  logo: React.ReactNode
  navLinks: React.ReactNode
}) {
  const {logo, navLinks} = props
  return (
    <div
      className="sign__header sign__header--auth-stack"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        gap: 14,
        width: '100%',
      }}
    >
      <div
        className="sign__header-auth-top"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          gap: 16,
        }}
      >
        <div style={{flexShrink: 0}}>{logo}</div>
        <LanguageSelector variant="auth" />
      </div>
      <div
        className="sign__header-auth-bottom"
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {navLinks}
      </div>
    </div>
  )
}
